import { render, staticRenderFns } from "./CollectionType.vue?vue&type=template&id=6b79e720&scoped=true&"
import script from "./CollectionType.vue?vue&type=script&lang=js&"
export * from "./CollectionType.vue?vue&type=script&lang=js&"
import style0 from "./CollectionType.vue?vue&type=style&index=0&id=6b79e720&lang=less&scoped=true&"
import style1 from "./CollectionType.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b79e720",
  null
  
)

export default component.exports